export default __webpack_public_path__ + "static/1-first-draft-4003b02841af0db077ff7419a47757c2.jpg";